import { BrandResponse, DepartmentResponse, PositionResponse } from '@/shared/types';
import api from '../api.client';

const BASE_URL = '/Brands';

const OrganizationService = {
  getBrands: async (signal?: AbortSignal): Promise<BrandResponse> => 
    api.get<BrandResponse>(BASE_URL, { signal }),

  getBrandDepartments: async (brandId: number, signal?: AbortSignal): Promise<DepartmentResponse> =>
    api.get<DepartmentResponse>(`${BASE_URL}/${brandId}/departments`, { signal }),

  getPositionsByBrandAndDepartment: async (
    brandId: number,
    departmentId: number,
    signal?: AbortSignal
  ): Promise<PositionResponse> =>
    api.get<PositionResponse>(
      `${BASE_URL}/${brandId}/departments/${departmentId}/positions`,
      { signal }
    ),
};

export default OrganizationService;
